import { useStyles } from "./Module2Icon.styles";
import { IModule2Icon } from "./Module2IconInterfaces";

const Module2Icon = ({ className, hideBackground }: IModule2Icon) => {
    const classes = useStyles();
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 54 54"
            className={`${classes.mainModule2IconWrapper} ${className || ""}`}
        >
            <defs>
                <clipPath id="clippath">
                    <rect x="11.5" y="9.5" width="31" height="35" fill="none" strokeWidth="0" />
                </clipPath>
            </defs>
            {!hideBackground && (
                <path
                    d="M27,0h0c14.91,0,27,12.09,27,27h0c0,14.91-12.09,27-27,27h0C12.09,54,0,41.91,0,27h0C0,12.09,12.09,0,27,0Z"
                    fill="#EF3340"
                    strokeWidth="0"
                />
            )}
            <g clipPath="url(#clippath)">
                <path
                    d="M29.99,29.5h-3.01v-11.82c0-.5-.41-.91-.91-.91s-.91.41-.91.91v11.82h-8.19c-2.01,0-3.64-1.63-3.64-3.64,0-1.59,1.02-2.94,2.43-3.44.27-.09.47-.3.56-.57.09-.27.05-.56-.11-.8-.39-.58-.62-1.27-.62-2.02,0-2,1.63-3.64,3.64-3.64.42,0,.82.08,1.19.2.25.09.52.06.74-.07.23-.12.39-.35.45-.6.43-2.06,2.26-3.61,4.45-3.61s4.03,1.55,4.45,3.62c.06.26.22.48.45.6.23.12.5.15.74.07.37-.13.77-.2,1.19-.2,1.82,0,3.33,1.34,3.6,3.08.02,0,.05,0,.08,0,.66,0,1.28.2,1.79.54,0-3-2.45-5.43-5.46-5.43-.28,0-.57.02-.85.07-.9-2.43-3.24-4.16-5.98-4.16s-5.08,1.73-5.98,4.16c-.28-.05-.56-.07-.85-.07-3.02,0-5.46,2.44-5.46,5.46,0,.75.15,1.46.43,2.11-1.62.94-2.7,2.7-2.7,4.7,0,3.01,2.45,5.46,5.46,5.46h8.19v6.36c0,.5.41.91.91.91s.91-.41.91-.91v-6.36h3.01v-1.82h0Z"
                    fill="#FFFFFF"
                    strokeWidth="0"
                />
                <path
                    d="M42.5,23.33v9.7c0,1.07-.87,1.94-1.94,1.94h-7.77c-1.07,0-1.95-.87-1.95-1.94v-9.7c0-1.07.87-1.94,1.95-1.94h1.5c.22-1.11,1.2-1.94,2.38-1.94s2.15.83,2.38,1.94h1.5c1.07,0,1.94.87,1.94,1.94ZM32.78,22.84c-.27,0-.48.22-.48.48v9.7c0,.27.22.48.48.48h7.77c.27,0,.48-.22.48-.48v-9.7c0-.27-.22-.48-.48-.48h-.48v.73c0,.4-.33.73-.73.73h-5.34c-.4,0-.73-.32-.73-.73v-.73h-.48ZM36.38,30.79c-.14.14-.32.21-.52.21s-.38-.08-.52-.21l-1.62-1.62c-.28-.28-.28-.74,0-1.03.28-.28.74-.28,1.03,0l1.11,1.1,2.72-2.72c.28-.28.74-.28,1.03,0,.28.28.28.74,0,1.03l-3.24,3.23ZM36.67,22.6c.4,0,.73-.33.73-.73s-.33-.73-.73-.73-.73.33-.73.73.33.73.73.73Z"
                    fill="#FFFFFF"
                    strokeWidth="0"
                />
                <path
                    d="M35.93,38.04c-7.44,0-8.72-4.8-8.94-6.36v-.46h-.05v-.02h-.79s-.97,0-.97,0v.02h-.05v.46c-.22,1.57-1.5,6.37-8.94,6.37-.5,0-.9.4-.9.9s.4.9.9.9c4.8,0,7.46-1.78,8.94-3.71v4.39s0,.1.01.19c-.05.23-.19.62-.56.98-.66.65-1.82,1-3.37,1h-.09c-.5,0-.9.4-.9.9s.4.9.9.91h.09c2.06,0,3.62-.51,4.64-1.52.08-.08.13-.15.2-.23.07.08.12.15.2.23,1.02,1.01,2.58,1.52,4.64,1.52h.09c.5,0,.9-.41.9-.91,0-.5-.41-.9-.9-.9h-.09c-3.18,0-3.8-1.4-3.92-1.96,0-.1.01-.19.01-.21v-4.39c1.48,1.94,4.15,3.71,8.94,3.71.5,0,.9-.4.9-.9s-.4-.9-.9-.9h0Z"
                    fill="#FFFFFF"
                    strokeWidth="0"
                />
            </g>
        </svg>
    );
};

export default Module2Icon;
